import React from "react";
import { ClipboardList, SearchCheck, ListChecks, HandCoins } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    title: "1. Solicitud",
    desc: "Completa el formulario con el monto y plazo que necesitas. Es 100% gratuito y sin compromiso.",
  },
  {
    icon: SearchCheck,
    title: "2. Evaluación",
    desc: "Las entidades financieras aliadas evalúan tu perfil crediticio de forma independiente.",
  },
  {
    icon: ListChecks,
    title: "3. Ofertas",
    desc: "Recibirás las propuestas que las entidades determinen según tu perfil, con tasa, CAE y cuota.",
  },
  {
    icon: HandCoins,
    title: "4. Elección",
    desc: "Tú decides qué oferta aceptar. La contratación se realiza directamente con la entidad elegida.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      className="py-20 lg:py-28 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Cómo funciona
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Cuatro pasos claros, sin letra chica
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Nuestro servicio compara opciones. La aprobación, tasa y condiciones
            finales son responsabilidad de la entidad financiera que te otorgue
            el crédito.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div
              key={i}
              className="relative group rounded-2xl bg-slate-50 border border-slate-200 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-blue-200"
              data-testid={`step-${i + 1}`}
            >
              <div className="h-11 w-11 rounded-xl bg-blue-600 text-white flex items-center justify-center mb-5">
                <s.icon className="h-5 w-5" strokeWidth={2} />
              </div>
              <h3 className="text-lg font-semibold text-slate-900">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {s.desc}
              </p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-3 w-6 h-px bg-slate-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
